<div class="container-fluid py-3">
    @if (view$ | async; as view) {
        <div class="d-flex justify-content-between">
            <div class="d-flex" style="gap: 0.75rem; white-space: nowrap">
                <span>
                    <i class="bi bi-exclamation-triangle-fill text-danger"></i>
                    {{ view.count.critical }}
                </span>
                <span>
                    <i class="bi bi-exclamation-circle-fill text-warning"></i>
                    {{ view.count.warning }}
                </span>
                <span>
                    <i class="bi bi-info-circle-fill text-info"></i>
                    {{ view.count.info }}
                </span>
            </div>
            <div class="d-flex" style="gap: 1rem">
                <app-input-date-range-picker
                    [formControl]="dateRangeFormControl"
                    [required]="true"></app-input-date-range-picker>
                <div class="d-flex align-items-end mb-3">
                    <button
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="
                            downloadLatestEventExportFile(
                                view.buildingNo,
                                dateRangeFormControl.getRawValue().startDate,
                                dateRangeFormControl.getRawValue().endDate
                            )
                        ">
                        {{ 'actions_export' | translate: 'online' : 'systems' }}
                    </button>
                </div>
            </div>
        </div>
        <div class="table-responsive w-100" [formGroup]="filterFormGroup">
            <table class="table table-striped">
                <thead>
                    <tr>
                        @for (columnHead of columnHeads; track columnHead) {
                            <th
                                app-sortable-table-header
                                [column]="columnHead.column"
                                (sort)="onSort($event)"
                                [label]="columnHead.label"></th>
                        }
                    </tr>
                    <tr>
                        @for (head of columnHeads; track $index) {
                            <th class="align-top">
                                @if (head.formType === 'text') {
                                    @if (head.formControl) {
                                        <app-input-text-group
                                            [formControl]="head.formControl"></app-input-text-group>
                                    }
                                }
                                @if (head.formType === 'typeAhead') {
                                    @switch (head.column) {
                                        @case ('meterModel') {
                                            @if (head.formControl) {
                                                <app-input-typeahead
                                                    [filterValues]="true"
                                                    [data]="view.meterModelsMap"
                                                    [formControl]="
                                                        head.formControl
                                                    "></app-input-typeahead>
                                            }
                                        }
                                        @case ('action') {
                                            @if (head.formControl) {
                                                <app-input-typeahead
                                                    [filterValues]="true"
                                                    [data]="view.actionMap"
                                                    [formControl]="
                                                        head.formControl
                                                    "></app-input-typeahead>
                                            }
                                        }
                                    }
                                }
                                @if (head.formType === 'date') {
                                    @if (head.formControl) {
                                        <app-input-date-group
                                            [formControl]="head.formControl"></app-input-date-group>
                                    }
                                }
                                @if (head.formType === 'selectMultiple') {
                                    @if (head.formControl) {
                                        <app-input-dropdown-checkboxes
                                            [formControl]="head.formControl" />
                                    }
                                }
                            </th>
                        }
                    </tr>
                </thead>
                <tbody class="position-relative">
                    @if (view.meterEvents.loading) {
                        <div
                            class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75">
                            <div style="background-color: transparent">
                                <app-load />
                            </div>
                        </div>
                    }
                    @for (
                        event of view.meterEvents.value
                            | slice: (page() - 1) * pageSize() : page() * pageSize();
                        track $index
                    ) {
                        <tr class="text-nowrap">
                            @for (head of columnHeads; track $index) {
                                @if (head.column === 'severity') {
                                    <td>
                                        @switch (event.severity) {
                                            @case ('CRITICAL') {
                                                <i
                                                    class="bi bi-exclamation-triangle-fill text-danger"></i>
                                            }
                                            @case ('WARNING') {
                                                <i
                                                    class="bi bi-exclamation-circle-fill text-warning"></i>
                                            }
                                            @case ('INFO') {
                                                <i class="bi bi-info-circle-fill text-info"></i>
                                            }
                                        }

                                        @switch (event[head.column]) {
                                            @case ('CRITICAL') {
                                                {{ 'utilities_TABLE_CRITICAL' | translate }}
                                            }
                                            @case ('WARNING') {
                                                {{
                                                    'common_warning'
                                                        | translate: 'online' : 'common'
                                                }}
                                            }
                                            @case ('INFO') {
                                                {{ 'utilities_INFO' | translate }}
                                            }
                                        }
                                    </td>
                                }
                                @if (head.column === 'proBraLoc') {
                                    <td>{{ event[head.column] }}</td>
                                }
                                @if (head.column === 'address') {
                                    <td>{{ event[head.column] }}</td>
                                }
                                @if (head.column === 'meterSuperType') {
                                    <td>
                                        {{
                                            'mappers_meterType.' + event[head.column]
                                                | translate: 'online' : 'common'
                                        }}
                                    </td>
                                }
                                @if (head.column === 'alloUnitType') {
                                    <td>
                                        @if (event[head.column] != null) {
                                            {{ event[head.column] }} -
                                            {{
                                                'mappers_allocationUnitMap.' + event[head.column]
                                                    | translate: 'online' : 'common'
                                            }}
                                        }
                                    </td>
                                }
                                @if (head.column === 'meterNo') {
                                    <td>
                                        {{ event.meterNo }}
                                        @if (event.printedSerialNo; as printedSerialNo) {
                                            ({{ printedSerialNo }})
                                        }
                                    </td>
                                }
                                @if (head.column === 'meterModel') {
                                    <td>{{ event[head.column] }}</td>
                                }
                                @if (head.column === 'mountingDate') {
                                    <td>
                                        {{ event[head.column] | appdate }}
                                    </td>
                                }
                                @if (head.column === 'dismountedDate') {
                                    <td>
                                        {{ event[head.column] | appdate }}
                                    </td>
                                }
                                @if (head.column === 'meterPlacement') {
                                    <td>{{ event[head.column] }}</td>
                                }

                                @if (head.column === 'eventType') {
                                    <td>
                                        {{ 'event-alarms_' + event[head.column] | translate }}
                                    </td>
                                }
                                @if (head.column === 'categoryName') {
                                    <td>
                                        {{
                                            'event-alarms_category_' + event[head.column]
                                                | translate
                                        }}
                                    </td>
                                }
                                @if (head.column === 'action') {
                                    <td>
                                        @if (event[head.column] != null) {
                                            {{ 'event-alarms_' + event[head.column] | translate }}
                                        }
                                    </td>
                                }
                                @if (head.column === 'createdDate') {
                                    <td>
                                        {{ event[head.column] | appdate }}
                                    </td>
                                }
                            }
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="100%" class="text-center">
                                {{ 'common_No-data-available' | translate }}
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="text-center">
            <app-pagination
                [collectionSize]="view.meterEvents.value.length"
                [page]="page()"
                (pageChange)="page.set($event)"
                [pageSize]="pageSize()"
                (pageSizeChange)="pageSize.set($event)"></app-pagination>
        </div>
    }
</div>
